import React, { Children } from 'react';
import { motion } from 'framer-motion';
export const SymptomsSection = () => {
  const symptoms = [{
    image: 'https://cdn.magicpatterns.com/uploads/jsCwmDPY56YM1QsD8CV4wa/FOTO_1.jpg',
    text: 'Vives en modo "supervivencia", agotado y sin vitalidad.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/tjN6UxazESJquUGNUixwBS/FOTO_2.jpg',
    text: 'Tomas pastillas o haces terapias eternas que solo tapan el síntoma.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/2JHmtENUJ1wiUVuiVuebbj/FOTO_3.png',
    text: 'Repites los mismos patrones de autosabotaje una y otra vez.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 bg-soft/30" data-id="element-116">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-118">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4" data-id="element-119">
            ¿Te pasa que...?
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-120">
          {symptoms.map((symptom, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-soft/50 overflow-hidden flex flex-col items-center text-center" data-id="element-121">
              <div className="w-full h-44 overflow-hidden" data-id="element-122">
                <img src={symptom.image} alt={symptom.text} className="w-full h-full object-cover" data-id="element-123" />
              </div>
              <div className="p-6" data-id="element-124">
                <p className="text-lg font-medium text-primary leading-relaxed" data-id="element-125">
                  {symptom.text}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="bg-primary text-white p-8 md:p-10 rounded-2xl text-center max-w-3xl mx-auto shadow-xl" data-id="element-126">
          <p className="text-xl md:text-2xl font-semibold leading-relaxed" data-id="element-127">
            No necesitas más esfuerzo. Se trata de quitar bloqueos, traumas y
            reprogramar creencias que te están frenando.
          </p>
        </motion.div>
      </div>
    </section>;
};